import React from 'react';
import {
  Box,
  Container,
  Typography,
  Link,
  Divider,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { School, Email, LocationOn } from '@mui/icons-material';
import { UI_VERSION, UI_CHANGELOG_PATH } from '../version';

const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: 'grey.100',
        py: 6,
        mt: 'auto',
        borderTop: '1px solid',
        borderColor: 'grey.300',
      }}
    >
      <Container maxWidth="xl">
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 4, mb: 4 }}>
          {/* Brand Section */}
          <Box sx={{ flex: '1 1 300px', minWidth: 0 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <School sx={{ mr: 1, color: 'primary.main', fontSize: 28 }} />
              <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
                <Typography component="span" variant="h6" sx={{ fontWeight: 800, color: 'primary.main', letterSpacing: '-0.5px' }}>
                  Study
                </Typography>
                <Typography component="span" variant="h6" sx={{ fontWeight: 800, color: 'secondary.main', letterSpacing: '-0.5px' }}>
                  Stride
                </Typography>
              </Box>
            </Box>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Empowering students to track their learning progress across the Scottish curriculum.
              Monitor achievements, set goals, and celebrate success.
            </Typography>
          </Box>

          {/* Quick Links */}
          <Box sx={{ flex: '1 1 300px', minWidth: 0 }}>
            <Typography variant="h6" color="text.primary" sx={{ mb: 2, fontWeight: 600 }}>
              Quick Links
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link href="/about-us" color="text.secondary" underline="hover">
                About Us
              </Link>
              <Link href="/how-it-works" color="text.secondary" underline="hover">
                How It Works
              </Link>
              <Link href="/curriculum-guide" color="text.secondary" underline="hover">
                Curriculum Guide
              </Link>
              <Link href="/support-center" color="text.secondary" underline="hover">
                Support Center
              </Link>
              <Link component={RouterLink} to={UI_CHANGELOG_PATH} color="text.secondary" underline="hover">
                Changelog
              </Link>
            </Box>
          </Box>

          {/* Contact Information */}
          <Box sx={{ flex: '1 1 300px', minWidth: 0 }}>
            <Typography variant="h6" color="text.primary" sx={{ mb: 2, fontWeight: 600 }}>
              Contact Us
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Email sx={{ mr: 1, color: 'primary.main', fontSize: 20 }} />
                <Link href="mailto:hello@studystride.app" color="text.secondary" underline="hover">
                  hello@studystride.app
                </Link>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <LocationOn sx={{ mr: 1, color: 'primary.main', fontSize: 20 }} />
                <Typography variant="body2" color="text.secondary">
                  Edinburgh, Scotland
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>

        <Divider sx={{ my: 3 }} />

        {/* Bottom Section */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
          <Typography variant="body2" color="text.secondary">
            © 2026 StudyStride. All rights reserved. · v{UI_VERSION}
          </Typography>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Link href="/privacy-policy" color="text.secondary" underline="hover" variant="body2">
              Privacy Policy
            </Link>
            <Link href="/terms-of-service" color="text.secondary" underline="hover" variant="body2">
              Terms of Service
            </Link>
            <Link href="/cookie-policy" color="text.secondary" underline="hover" variant="body2">
              Cookie Policy
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
